<script setup lang="ts">
import { useSlots } from "vue";

const props = withDefaults(
  defineProps<{
    selectedIdx?: number;
    disable?: boolean;
  }>(),
  {
    selectedIdx: 0,
    disable: false,
  }
);
const emit = defineEmits<{
  (e: "update:selectedIdx", idx: number): void;
}>();
const slots = useSlots();

const onClick = (idx: number) => {
  if (props.disable) return;
  emit("update:selectedIdx", idx);
};
</script>
<template>
  <div
    class="flex border w-fit rounded-full overflow-hidden text-xs items-center h-fit"
  >
    <div
      v-for="(item, idx) in slots.default?.()[0].children"
      :key="idx"
      :class="[
        'border-r last:border-r-0 px-2 py-1 cursor-pointer  h-ull',
        disable && 'opacity-50',
        selectedIdx === idx && ' bg-primary text-primary-content',
      ]"
      @click="onClick(idx as number)"
    >
      <component :is="item" />
    </div>
  </div>
</template>
